import { jsx as _jsx } from "react/jsx-runtime";
import { MOTION } from '../system/motion';
export function Toggle({ on, onChange, disabled, label, labelledBy, }) {
    return (_jsx("button", { type: "button", role: "switch", onClick: onChange, disabled: disabled, "aria-checked": on === true, "aria-label": labelledBy === undefined ? label : undefined, "aria-labelledby": labelledBy, style: {
            width: 36, height: 20, borderRadius: 999,
            background: on ? 'var(--primary)' : 'var(--border-strong)',
            border: 'none',
            padding: 2,
            position: 'relative',
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            transition: MOTION.transition,
            flexShrink: 0,
        }, children: _jsx("span", { style: {
                width: 16, height: 16, borderRadius: 999,
                background: 'var(--background)',
                display: 'block',
                transform: on ? 'translateX(16px)' : 'translateX(0)',
                transition: MOTION.transition,
            } }) }));
}
//# sourceMappingURL=Toggle.js.map